import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Contact from './contact';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Contacts = (props) => {
  const { isEditable, contacts, form, disabled } = props;
  if (!contacts || !contacts.length) {
    return null;
  }
  // sort contacts so the default ones come first
  const sortedContacts = contacts.reduce((acc, element) => {
    if (!element.isDefault) {
      return [...acc, element];
    }
    return [element, ...acc];
  }, []);

  if (isEditable) {
    const { getFieldDecorator } = form;
    getFieldDecorator('contactPeople', { initialValue: sortedContacts });
  }

  return (
    <Wrapper>
      {sortedContacts?.map(
        (contact, idx) =>
          contact &&
          <Contact
            index={idx}
            id={contact.id}
            key={`${contact.id}_${idx}`}
            contact={contact}
            isEditable={isEditable}
            disabled={disabled}
            form={form}
          />
        ,
      )}
    </Wrapper>
  );
};

Contacts.propTypes = {
  isEditable: PropTypes.bool,
  disabled: PropTypes.bool,
  contacts: PropTypes.array,
  form: PropTypes.object,
};

export default Contacts;
